module.exports = __webpack_public_path__ + "static/img/200072.0e916270.png";